import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const ChatbotList = Loadable(lazy(() => import("./ChatbotList")));

export const chatbotRoutes = [
  {
    path: "/chats",
    exact: true,
    element: (
      <AuthorizedRoute
      allowFullAccess
      moduleIds={[ALLOWED_MODULES.CHATS]}>
        <ChatbotList />
      </AuthorizedRoute>
    ),
  },
];
